// removed by extract-text-webpack-plugin
module.exports = {"BuildControls":"BuildControls__BuildControls__-hash--base64-5-","OrderButton":"BuildControls__OrderButton__-hash--base64-5-","enable":"BuildControls__enable__-hash--base64-5-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/BuildControls/BuildControls.css
// module id = 94
// module chunks = 0